export default "/images/vendor/intl-tel-input/build/flags@2x.webp?11151219817c4593cbfaede705cfcd30";